import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Outlet } from 'react-router-dom';

import { useSessionStore } from 'session/useSessionStore';
import { LoginLoader } from './LoginLoader';

export const CognitoRouteWrapper = () => {
    const auth = useAuth();
    const setJwt = useSessionStore(state => state.setJwtToken);

    useEffect(() => {
        if (!auth.isLoading && !auth.isAuthenticated) {
            const currentPath = window.location.pathname + window.location.search;
            auth.signinRedirect({ url_state: currentPath });
        } else if (auth.isAuthenticated) {
            const jwt = auth.user?.id_token;
            setJwt(jwt!);
        }
    }, [auth]);

    return (
        auth.isLoading || !auth.isAuthenticated ?
            <LoginLoader withCallback={false}/>
            :
            <Outlet/>
    );
};